<!-- THE STUDIO BAR (nav 7b) — Spotlight's bar, a card for the latest reply or question, and a Conversation panel (R2). -->
<!-- The bar, its card, its Conversation panel and its button all follow `light`: the tone of the screen it is on. -->
<ng-container *ngIf="visible">
  <app-spotlight-bottom-bar
    [showBack]="false" [showAtlas]="false" [showForge]="false"
    placeholder="Ask, or say where to go"
    [crumbs]="crumbs"
    [busy]="session.busy"
    [inputText]="input"
    [cardTemplate]="cardTpl"
    [rightInset]="panelOpen ? 360 : 168"
    [stoppable]="false"
    [light]="light"
    (submit)="send($event)"
    (inputTextChange)="input = $event"
    (navigate)="panelOpen = true">
  </app-spotlight-bottom-bar>

  <ng-template #cardTpl>
    <!-- Was (2026-10-05, nav 7b live check, L1 — no positioning, so the card rendered at the composer's own
      y, under it; the entity chat's card (zs-entity-chat.component.html #zs-entity-card) uses this same
      positioning): class="rounded-xl border border-gray-700/60 bg-gray-900/95 px-3 py-2.5 text-[13px] text-gray-100 shadow-xl" -->
    <!-- Was (2026-10-15), before the white variant — the colours sat in the class:
      the card: border-gray-700/60 bg-gray-900/95 text-gray-100; its close: text-gray-500 hover:bg-gray-800 hover:text-white;
      a choice: bg-gray-800 text-sky-300 hover:bg-gray-700 -->
    <div *ngIf="session.card || lastReply" id="studio-nav-card"
      class="absolute bottom-full left-0 right-0 mb-2 z-[211] max-h-[60vh] overflow-y-auto rounded-xl border px-3 py-2.5 text-[13px] shadow-xl"
      [ngClass]="light ? 'border-gray-200 bg-white text-gray-800' : 'border-gray-700/60 bg-gray-900/95 text-gray-100'">
      <button type="button" (click)="close()" aria-label="Close"
        class="float-right -mr-1 -mt-0.5 h-6 w-6 rounded-md text-base leading-none transition-colors duration-150"
        [ngClass]="light ? 'text-gray-500 hover:bg-gray-100 hover:text-gray-900' : 'text-gray-500 hover:bg-gray-800 hover:text-white'">&times;</button>
      <div class="whitespace-pre-wrap">{{ session.card?.text ?? lastReply }}</div>
      <div *ngIf="session.card" class="mt-2 flex flex-wrap gap-1.5">
        <button *ngFor="let o of session.card.options; trackBy: byIndex" type="button" (click)="choose(o.id)"
          class="rounded-md px-2.5 py-1 text-xs transition-colors duration-150"
          [ngClass]="light ? 'bg-gray-100 text-sky-700 hover:bg-gray-200' : 'bg-gray-800 text-sky-300 hover:bg-gray-700'">{{ o.label }}</button>
      </div>
    </div>
  </ng-template>

  <!-- Was (2026-10-15), before the white variant — the colours sat in the class:
    the panel: border-gray-800 bg-gray-950/95 text-gray-200; its title text-gray-300;
    its close: text-gray-500 hover:bg-gray-800 hover:text-white -->
  <aside *ngIf="panelOpen" class="fixed top-[68px] right-0 bottom-12 z-[211] flex w-[360px] flex-col border-l shadow-2xl backdrop-blur-sm" aria-label="Conversation"
    [ngClass]="light ? 'border-gray-200 bg-white/95 text-gray-800' : 'border-gray-800 bg-gray-950/95 text-gray-200'">
    <header class="flex shrink-0 items-center px-4 pb-2 pt-3">
      <span class="text-xs font-medium" [ngClass]="light ? 'text-gray-600' : 'text-gray-300'">Conversation</span>
      <span class="flex-1"></span>
      <button type="button" (click)="panelOpen = false" aria-label="Close panel"
        class="h-7 w-7 rounded-md text-lg leading-none transition-colors duration-150"
        [ngClass]="light ? 'text-gray-500 hover:bg-gray-100 hover:text-gray-900' : 'text-gray-500 hover:bg-gray-800 hover:text-white'">&times;</button>
    </header>
    <!-- Was (2026-10-06, nav 8b Task 3): <div class="min-h-0 flex-1 overflow-y-auto"><app-studio-history [entries]="historyEntries"></app-studio-history></div> -->
    <!-- Was (2026-10-15): <div class="min-h-0 flex-1 overflow-y-auto"><app-shared-history></app-shared-history></div> -->
    <div class="min-h-0 flex-1 overflow-y-auto"><app-shared-history [light]="light"></app-shared-history></div>
  </aside>

  <!-- Was (2026-10-15): [ngClass]="panelOpen ? 'bg-blue-600 text-white hover:bg-blue-500' : 'bg-gray-900 text-gray-50 hover:bg-gray-700'" — open stays blue on either screen. -->
  <button type="button" id="studio-nav-panel-toggle" (click)="panelOpen = !panelOpen"
    class="fixed bottom-2 right-3 z-[210] flex h-8 items-center gap-2 rounded-full px-3 text-xs font-medium shadow-sm transition-colors duration-150"
    [ngClass]="panelOpen ? 'bg-blue-600 text-white hover:bg-blue-500' : light ? 'bg-white text-gray-800 hover:bg-gray-100' : 'bg-gray-900 text-gray-50 hover:bg-gray-700'"
    [attr.aria-pressed]="panelOpen" [title]="panelOpen ? 'Hide the conversation' : 'Show the conversation'">
    <svg class="h-4 w-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
      <rect x="3" y="4" width="18" height="16" rx="2"></rect><path d="M15 4v16"></path>
    </svg>
    <span>{{ panelOpen ? 'Hide panel' : 'Conversation' }}</span>
  </button>
</ng-container>
